import script from "./paging.vue?vue&type=script&lang=ts&setup=true"
export * from "./paging.vue?vue&type=script&lang=ts&setup=true"

import "./paging.vue?vue&type=style&index=0&id=2e1130d7&lang=less&scoped=true"

import exportComponent from "/Volumes/未命名/repos/qll-web-work/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e1130d7"]])

export default __exports__